import { render, staticRenderFns } from "./InventoryExpiring.vue?vue&type=template&id=6f94a4c4&"
import script from "./InventoryExpiring.vue?vue&type=script&lang=js&"
export * from "./InventoryExpiring.vue?vue&type=script&lang=js&"
import style0 from "./InventoryExpiring.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports